import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
import { getCookieConsentConfig } from './cookieconsent-config.js';

export default {
    install: (app) => {
        app.config.globalProperties.$CookieConsent = CookieConsent;

        if (typeof window !== 'undefined') {
            CookieConsent.run(getCookieConsentConfig());
        }
    }
};
